import { GetOrderResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetOrderResultModel } from './get-order-result.state';

/** StateDetailsActions */
const ACTION_SET = '[GetOrderResult] set';
const ACTION_UPDATE = '[GetOrderResult] update';
const ACTION_RESET = '[GetOrderResult] reset';
const ACTION_FAIL = '[GetOrderResult] fail';
const ACTION_CANCEL_REQUEST = '[GetOrderResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetOrderResult] set from api';
const ACTION_UPDATE_FROM_API = '[GetOrderResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetOrderResult = createAction(ACTION_SET, props<WithRequestId<GetOrderResultModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetOrderResult = createAction(ACTION_UPDATE, props<WithRequestId<Partial<GetOrderResultModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetOrderResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetOrderResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetOrderResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetOrderResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetOrderResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetOrderResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetOrderResponse>>()
);
